import { Register } from "./register.feature";

export default Register;
